import React from 'react';
import Dialog from '@material-ui/core/Dialog'
import Chip from '@material-ui/core/Chip';
import styles from './style.module.css' 
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import Table from "../../../views/Table/Table.js";
import {getCouponDetails} from '../Coupon.api';
import moment from "moment";
const CouponDetail = (props) => {
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [selectedProducts, setSelectedProducts] = React.useState([]);
    const [selectedCategories, setSelectedCategories] = React.useState([]);    
    // let selectedUsers = [];
    // let selectedProducts = [];
    // let selectedCategories = [];
    var sdate = moment(props.coupon.startDate).format('DD-mm-yyyy');
    var startDate = sdate;
    var date = moment(props.coupon.expiryDate).format('DD-mm-yyyy');
    var expiryDate = date;
    React.useEffect(() => {
        getCouponDetails(props.coupon).then((res) => {
            console.log("coupon details");
            console.log(res.data);
            if(res.success) {
                let data = res.data;
                let userDetails =data['userDetails'];
                let productDetails =data['productDetails'];
                let categoryDetails =data['categoryDetails'];
                if(userDetails.length > 0 ) {
                    console.log('in:user');
                    let x = [...userDetails];
                    // selectedUsers = x;
                    console.log(x);    
                    setSelectedUsers([...userDetails]);
                }
                if(productDetails.length > 0 ) {
                    console.log('in:products');
                    setSelectedProducts([...productDetails]);    
                }
                if(categoryDetails.length > 0 ) {
                    console.log('in:category');
                    setSelectedCategories([...categoryDetails]);    
                } 
            }
        }).catch(err=>console.log(err));
    },[]);
    return (
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'lg'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>Coupon Detail</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>
                    <div className={styles.content}>
                        <div className={styles.row}>
                            <p>
                                Code: 
                                <span>{props.coupon.couponCode}</span>
                            </p>

                            <p>
                                Coupon Type: 
                                <span>{props.coupon.couponType}</span>
                            </p>
                        </div>
                        <div className={styles.row}>
                            <p>
                                Discount Amount: 
                                <span>{props.coupon.discountAmount}</span>
                            </p>

                            <p>
                                Discount Percentage: 
                                <span>{props.coupon.discountPercentage}</span>
                            </p>
                        </div>
                        <div className={styles.row}>
                            <p>
                                Min Order Amount: 
                                <span>{props.coupon.minOrderAmount}</span>
                            </p>

                            <p>
                                Max Discount Amount: 
                                <span>{props.coupon.maxDiscountAmount}</span>
                            </p>
                        </div>
                        <div className={styles.row}>
                            <p>
                                Start Date: 
                                <span>{startDate}</span>
                            </p>

                            <p>
                                Expiry Date: 
                                <span>{expiryDate}</span>
                            </p>
                        </div>
                        <div className={styles.row}>
                            <p>
                                Usage Limit(per user): 
                                <span>{props.coupon.usagelimit}</span>
                            </p>

                            <p>
                                Description: 
                                <span>{props.coupon.couponDescription}</span>
                            </p>
                        </div>
                    </div>
                    <h2 style={{marginTop:20,marginBottom:20}}>Specifications Details</h2>
                    <h2 style={{marginTop:20,marginBottom:10}}>Users: {selectedUsers && selectedUsers.length>0? selectedUsers.length+' selected':' ALL selected'}</h2>
                    {selectedUsers && selectedUsers.length > 0 && selectedUsers.map((item) => {
                         return (<Chip label={item.name} />)}) 
                        // <Table
                        // tableHeaderColor="primary"
                        // tableHead={["Id","Name","Contact"]}
                        // tableData={selectedUsers}
                        // />
                    }
                     

                    <h2 style={{marginTop:20,marginBottom:10}}>Category: {selectedCategories && selectedCategories.length>0? selectedCategories.length+' selected':' ALL selected'}</h2>
                    {selectedCategories && selectedCategories.length > 0 && selectedCategories.map((item) => {
                         return (<Chip label={item.displayName} />)    
                    }) 
                        // <Table
                        //     tableHeaderColor="primary"
                        //     tableHead={["Id","Name"]}
                        //     tableData={selectedCategories}
                        // />
                    }
                    <h2 style={{marginTop:20,marginBottom:10}}>Products: {selectedProducts && selectedProducts.length>0? selectedProducts.length+' selected':' ALL selected'}</h2>
                    {selectedProducts && selectedProducts.length>0 && selectedProducts.map((item) => {
                         return (<Chip label={item.displayName} />)    
                    })
                        // <Table
                        // tableHeaderColor="primary"
                        // tableHead={["Name"]}
                        // tableData={selectedProducts}
                        // />
                    }    
                </div>
            </div>
        </Dialog>
    )
}

export default CouponDetail;